export default __webpack_public_path__ + "static/media/HHLogo.a975645f.png";